import { Layout } from "@certn/cascadia-react";
import { CascadiaIllustration } from "@certn/cascadia-tokens";
import { ReactNode } from "react";

import { AppFooter } from "./app-footer";
import { AppHeader } from "./app-header";
import { EmptyState } from "./empty-state/EmptyState";

interface Props extends React.PropsWithChildren {
  illustration?: CascadiaIllustration;
  title: string;
  message: string | ReactNode;
}

export function FullScreenErrorPage(props: Props) {
  const { title, message, illustration = "verification-fail" } = props;

  return (
    <Layout
      layout="applicant/narrow"
      header={<AppHeader hideSettings />}
      footer={<AppFooter />}
    >
      <EmptyState
        title={title}
        description={message}
        illustration={illustration}
      />
      {props.children}
    </Layout>
  );
}
